export default __webpack_public_path__ + "static/media/toyzone.af320a84750299dfc68dc1596ce8801f.svg";